<app-tenant-form (onSubmitCallback)="onSubmit($event[0])"></app-tenant-form>
